import React from 'react'
import ProductSuggestion from './ProductSuggestion'
import About from './About'
import Download from './Download'
import Testimonial from './Testimonial'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel CSS
import 'owl.carousel/dist/assets/owl.theme.default.css'; // Import Owl Carousel Theme
import slide from '../../Assets/images/splash-img.png';
import { useState, useEffect } from 'react'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { bannerPicUrl, userPicUrl } from '../../utils/Helper'
import FrontLoader from '../layout/FrontLoader'
import BannerImage from '../../Assets/images/bannerDefult.png'
import { LanguageConstants } from '../../constants/LanguageConstants'

function Home() {
  const [bannerdata, setBannerdata] = useState([])
  const [productdata, setProductdata] = useState([])
  const [testimonial, setTestimonialdata] = useState([])


  const HomeApi = useMakeRequest()
  useEffect(() => {
    HomeApi.makeRequest({ url: ApiConstants?.Homepage, toastStatus: false })
  }, [])
  useEffect(() => {
    if (HomeApi?.status) {
      setBannerdata(HomeApi?.data?.data?.banners)
      setProductdata(HomeApi?.data?.data?.products)
      setTestimonialdata(HomeApi?.data?.data?.testimonials)
    }
  }, [HomeApi?.status])
  const options = {
    loop: true, // Enable infinite loop
    margin: 10, // Space between items
    nav: false,
    dots: true,
    items: 1,
    autoplay: true,        // Enable autoplay
    autoplayTimeout: 3000, // Autoplay interval (3000ms = 3 seconds)
    autoplayHoverPause: false, // Pause autoplay on hover
    dotsEach: bannerdata?.length > 5 ? Math.ceil(bannerdata?.length / 5) : false,
  };

  console.log(bannerdata?.length , "=============>>>.");

  return (
    <>
    {HomeApi?.loading ? <FrontLoader/> : null}
      <section className="main-banner-slide">
        {bannerdata?.length > 0 ?
          <OwlCarousel className="owl-theme" key={bannerdata.length} {...options}>
            {bannerdata?.map((res: any, i: any) => (
              <>
                <div className="item" key={i}>
                  <a target='_blank' href={res?.banner_details?.banner_url} >
                    <img alt="slide" src={bannerPicUrl(res?.banner_image_details?.file_path)} height={'500'}/>
                    <div className='hovertext'>
                      <div className="container">
                        <h1 className="banner-heading">{res?.banner_details?.name}</h1>
                      </div>
                    </div>
                  </a>
                </div>
              </>
            ))}
          </OwlCarousel> : 
          <OwlCarousel className="owl-theme" {...options}>
                <div className="item" >
                  <a target='_blank'  >
                    <img alt="slide" src={BannerImage} height={'500'}/>
                    <div className='hovertext'>
                      <div className="container">
                        <h3 style={{color:'white'}}>{LanguageConstants?.DATANOTFOUND}</h3>
                      </div>
                    </div>
                  </a>
                </div>
          </OwlCarousel>
        }
      </section>
      <ProductSuggestion data={productdata} />
      <About />
      <Download />
      <Testimonial data={testimonial}/>

    </>
  )
}

export default Home